import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const getAssessmentDetail2 = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('assessment/info2/' + uuid).then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const startAssessment = (uuid, courseId, sessionId) => {
  const hostname = window.location.hostname || 'mobile.pragyasystems.com'
  let url = 'attempt/launchAssessmentWizard/' + uuid + '?courseId=' + courseId + '&hostname=' + hostname
  if (sessionId) {
    url += '&sessionId=' + sessionId
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url).then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}
export const getRichHtmlAssessment = (ancestor) => {
  return getItem('token').then(token => {
    return HTTP(token).get('assessment/childRichHtml/' + ancestor)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const updateLaunchedAttempt = (sessionId, externalId, isFinished) => {
  return getItem('token').then(token => {
    return HTTP(token).put('attempt/attemptFinished/' + sessionId + '?externalId=' + externalId + '&isFinished=' + isFinished)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearningTopicDetails = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('topic/' + uuid).then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearningContentDetails = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('learningcontent/' + uuid).then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const populateAttemptReport = (activityId, sessionId, courseId) => {
  const hostname = window.location.hostname || 'mobile.pragyasystems.com'
  let url = 'attempt/launchReportWizard/' + activityId + '?sessionId=' + sessionId + '&courseId=' + courseId + '&hostname=' + hostname
  return getItem('token').then(token => {
    return HTTP(token).get(url).then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const startLearningActivity = (activity) => {
  return getItem('token').then(token => {
    return HTTP(token).put('learningActivityEvent/start/' + activity.entityUuid + '/' + activity.userId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const continueLearningActivity = (activity) => {
  return getItem('token').then(token => {
    return HTTP(token).put('learningActivityEvent/continue/' + activity.entityUuid + '/' + activity.userId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const stopLearningActivity = (activity) => {
  return getItem('token').then(token => {
    return HTTP(token).put('learningActivityEvent/stop/' + activity.entityUuid + '/' + activity.userId + '/' + activity.rating)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const saveRating = (ratingInfo) => {
  return getItem('token').then(token => {
    return HTTP(token).put('rating', ratingInfo)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const scormLaunchURL = (entity) => {
  const hostname = window.location.hostname || 'mobile.pragyasystems.com'
  let url = '/scorm/registration?scormId=' + entity.scormId + '&assetId=' + entity.uuid + '&courseId=' + entity.courseId + '&hostname=' + hostname
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}
export const scormLaunchURLWithToken = (entity) => {
  let hostname = window.location.hostname
  if (hostname) {
    hostname += '/vue'
  }
  let url = '/scorm/registration?scormId=' + entity.scormId + '&assetId=' + entity.assetId + '&courseId=' + entity.courseId + '&hostname=' + hostname
  return HTTP(entity.token).get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getScormDetails = (uuid, token) => {
  return HTTP(token).get('learningActivityEvent/scormdone/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getToolProxies = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/toolProxy/toolInCourse/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getKCMessage = (entityId, courseType) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/KCMessage/' + entityId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getKCDescription = (entityId, courseType, courseId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/KCDescription/' + entityId + '/' + courseType + '/' + courseId)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
    })
  })
}

export const getDiagnosticTestReport = (courseId, assessmentId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('competency/diagnosticreport/' + courseId + '/' + assessmentId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/assessment/api.js